<div class="container"
     #container>
    <aa-chart *ngIf="isReady" [dimensions]="dimensions"
              [title]="chartingService.config.title">
        <svg:g aaGridHor
               *ngIf="chartingService.config.rendering.gridHor"
               [dimensions]="dimensions"
               [scale]="yScale">
        </svg:g>
        <svg:g aaGridVer
               *ngIf="chartingService.config.rendering.gridVer"
               [dimensions]="dimensions"
               [scale]="xScale">
        </svg:g>
        <svg:g aaAxis
               orientation="x"
               [dimensions]="dimensions"
               [scale]="xScale"
               [formatTick]="xFormatTick"
               [label]="chartingService.config.xLabel">
        </svg:g>
        <svg:g aaAxis
               orientation="y"
               [dimensions]="dimensions"
               [scale]="yScale"
               [formatTick]="yFormatTick"
               [label]="chartingService.config.yLabel">
        </svg:g>
        <svg:g *ngFor="let serie of series">
            <svg:g aaLine
                   [dimensions]="dimensions"
                   [serie]="serie">
            </svg:g>
            <svg:g aaCircles
                   [dimensions]="dimensions"
                   [serie]="serie"
                   [keyAccessor]="keyAccessor">
            </svg:g>
        </svg:g>
        <svg:g aaTooltip
               [hovered]="hovered"
               [dimensions]="dimensions"
               [tooltipData]="tooltipData"
               [formatTick]="yFormatTick">
        </svg:g>
        <svg:g aaLegend
               [dimensions]="dimensions"
               [series]="series"
               [config]="chartingService.config.legend"
               (toggleSerieVisibility)="onToggleSerieVisibility()">
        </svg:g>
        <svg:g aaListeningZone
               [dimensions]="dimensions"
               (mousePosition)="onMousePosition($event)"
               (hovered)="onHovered($event)">
        </svg:g>
    </aa-chart>
</div>
